﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import HoldingsAndTrades from "./HoldingsAndTrades.svelte";
import DocumentUpload from "./DocumentUpload.svelte";
import Confirmation from "./Confirmation.svelte";
import Review from "./Review.svelte";
import ThankYou from "./ThankYou.svelte";
import Error from "../Error.svelte";
import Verify from "./Verify.svelte";
import RegistrationComplete from "./RegistrationComplete.svelte";

const title = projectSettings.classActionName;


const registrationPageList = [
	{
		pageIndex: 0,
		component: LandingPage,
		//title: "Landing Page",
		removeTrackerOnPage: true,
		showInTracker: false,
		routeId: "/Registration",
		nextPage: "Registration/PersonalDetails",
		properties: {
			pageTitle: `${projectSettings.classActionName}`,
			lastVisitedPage: "Landing Page"
		}
	},
	{
		pageIndex: 1,
		component: PersonalDetails,
		title: "Personal Details",
		showInTracker: true,
		previousPage: "/Registration",
		routeId: "/Registration/PersonalDetails",
		nextPage: "Registration/HoldingsAndTrades",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Personal Details`,
			persistUrl: "/api/project",
			lastVisitedPage: "Personal Details"
		}
	},
	{
		pageIndex: 2,
		component: HoldingsAndTrades,
		title: "Holdings and Trades",
		showInTracker: true,
		previousPage: "/Registration/PersonalDetails",
		routeId: "/Registration/HoldingsAndTrades",
		nextPage: "Registration/DocumentUpload",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Holdings and Trades`,
			persistUrl: "/api/project",
			lastVisitedPage: "Holdings and Trades"
		}
	},
	{
		pageIndex: 3,
		component: DocumentUpload,
		title: "Document Upload",
		showInTracker: true,
		previousPage: "/Registration/HoldingsAndTrades",
		routeId: "/Registration/DocumentUpload",
		nextPage: "Registration/Confirmation",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Document Upload`,
			persistUrl: "/api/project",
			lastVisitedPage: "Document Upload"
		}
	},
	{
		pageIndex: 4,
		component: Confirmation,
		title: "Confirmation",
		showInTracker: true,
		routeId: "/Registration/Confirmation",
		previousPage: "/Registration/DocumentUpload",
		nextPage: "Registration/ThankYou",
		properties: {
			pageTitle: `${projectSettings.classActionName} - Confirmation`,
			nextPageLabel: "Submit",
			persistUrl: `/api/registration?timezoneOffset=${-1 * new Date().getTimezoneOffset()}`,
			lastVisitedPage: "Confirmation"
		}
	},
	{
		pageIndex: 5,
		component: ThankYou,
		title: "Registration Submitted",
		showInTracker: false,
		routeId: "/Registration/ThankYou",
		properties: {
			pageTitle: `${title} - Thank you`
		}
	},
	{
		pageIndex: 6,
		component: Review,
		title: "Review",
		showInTracker: false,
		routeId: "/Review",
		properties: {
			pageTitle: `${title} - Review`
		}
	},
	{
		pageIndex: 7,
		component: Error,
		title: "Error",
		showInTracker: false,
		routeId: "*/Error",
		properties: {
			pageTitle: `${title} - Error`
		}
	},
	{
		pageIndex: 8,
		component: Verify,
		title: "Claimant Registration Form",
		showInTracker: false,
		routeId: "/Verify",
		nextPage: "/Registration/PersonalDetails",
		properties: {
			pageTitle: `${title} - Verify`
		}
	},
	{
		pageIndex: 9,
		component: RegistrationComplete,
		title: "REGISTRATION SUBMITTED",
		showInTracker: false,
		routeId: "/RegistrationComplete",
		properties: {
			pageTitle: `${title}`
		}
	}
];

export default registrationPageList;
